module.exports = "https://r.nearpod.com/assets/media/image/user_green_icon-4106ca7f8d69d56ac02dc3afe0505df2.svg";